import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Space, Tag } from 'antd'

import ActionButton from '../ActionButton'

const ColumnItem = ({ column, row, content, handleClick = () => {} }) => {
	const history = useHistory()

	if (column.type === 'title') {
		return (
			<Space size="small">
				<Button type="link" onClick={() => history.push(`/demands/${row.id}`)}>
					{content}
				</Button>
			</Space>
		)
	}

	if (column.type === 'priority') {
		let color = 'gray'
		switch (content) {
			case 'Baixa':
				color = 'geekblue'
				break
			case 'Média':
				color = 'warning'
				break
			case 'Alta':
				color = 'volcano'
				break
			case 'Urgente':
				color = 'error'
				break
			default:
				break
		}

		return (
			<Tag color={color} key={row.id}>
				{content}
			</Tag>
		)
	}

	if (column.type === 'status') {
		let color = 'gray'
		switch (content) {
			case 'Aguardando ação':
				color = 'processing'
				break
			case 'Em Validação':
				color = 'geekblue'
				break
			case 'Em Revisão':
				color = 'cyan'
				break
			case 'Em Assinatura':
				color = 'purple'
				break
			case 'Concluído':
				color = 'success'
				break
			case 'Atrasado':
				color = 'error'
				break
			case 'Cancelado':
				color = 'orange'
				break
			case 'Arquivado':
				color = 'gold'
				break
			default:
				break
		}

		return (
			<Tag color={color} key={row.id}>
				{content}
			</Tag>
		)
	}

	if (column.type === 'action') {
		const items = column.actions.map((action) => ({
			...action,
			onClick: () => action.onClick(row),
		}))

		return (
			<ActionButton
				content={{
					items,
				}}
			/>
		)
	}

	if (column.type === 'date') {
		return new Date(content).toLocaleDateString('pt-BR')
	}

	return content
}

export default ColumnItem
